import StoryPost from "../../components/info/story-post"
import { useParams } from 'react-router-dom';

const StoryPostPage = () => {
    const { slug } = useParams();
    return <StoryPost slug={slug} />
}

export default StoryPostPage;